module.exports = __webpack_public_path__ + "static/img/img_ewm_b.eb6a6f62.png";